// Loads the YouTube iframe only after a click on the preview image (templates/v2/partials/youtube-player.html.twig)
class YoutubePlayer {
  constructor() {
    this.players = document.querySelectorAll('.js-youtube-player');
  }

  init() {
    if (this.players.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.players.forEach((player) => {
      const button = player.querySelector('.youtube-player-button');

      if (!button) return;

      button.addEventListener('click', () => {
        this.play(player);
      });
    });
  }

  play(player) {
    const iframe = document.createElement('iframe');
    // Bedienelemente des Players in der Seitensprache (de/fr/it), sonst nimmt YouTube die Browsersprache
    const lang = document.documentElement.lang ? `&hl=${encodeURIComponent(document.documentElement.lang)}` : '';

    // enablejsapi + origin: damit der YouTube-Trigger in GTM den Player erkennt (gtm.video: Start, Pause, Fortschritt, Ende)
    const api = `&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;

    iframe.src = `https://www.youtube-nocookie.com/embed/${player.dataset.youtubeId}?autoplay=1&rel=0${lang}${api}`;
    iframe.title = player.dataset.youtubeTitle;
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');

    player.classList.add('is-playing');
    player.innerHTML = '';
    player.appendChild(iframe);
    this.loadApi();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      section: player.closest('section[id]')?.id || '',
      element: 'Video_Start',
      module: 'youtube-video-' + player.dataset.youtubeId,
      topic: player.closest('[data-event-topic]')?.dataset.eventTopic || '',
      href: 'https://www.youtube.com/watch?v=' + player.dataset.youtubeId,
    });
  }

  // Der YouTube-Trigger in GTM braucht die iframe-API, sonst erkennt er nachträglich eingefügte Player nicht
  // (auf Seiten mit dem v1-Brick «Video» lädt dieser sie schon). Erst beim Klick laden: vorher keine Anfrage an YouTube.
  loadApi() {
    if (window.YT || document.querySelector('script[src*="youtube.com/iframe_api"]')) return;

    const script = document.createElement('script');

    script.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(script);
  }
}

export default new YoutubePlayer();
